import React from 'react';

import { ToggleLeftMenu } from '../../left-menu/left-menu-container';
import '../css/filter-compare-toggle.less';


export default ({ defaultExpanded, text='Filters & Compare' }) => {
    return (<ToggleLeftMenu defaultExpanded={defaultExpanded}>
    {
        ({ dispatchMenuState, leftMenuActive}) => {
        return (
        <button 
            className={`toggle-left-menu unstyled ${leftMenuActive ? ' active':''}`}
            onClick={() => { dispatchMenuState(!leftMenuActive)}}
        >
            {`${leftMenuActive ? 'Hide' : 'Show'} ${text}`}
            {
            [0,1].map(i => (
                <span key={i} className={`hp-icon ${leftMenuActive ? 'page-left':'page-right'}`}></span>
            ))
            }
        </button>)
        }
    } 
    </ToggleLeftMenu>)
}